import React, { useEffect, useState } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
import { templateJson } from './json/templateJson'
// import { useParams } from 'react-router-dom'
// import ShareBtn from './ShareBtn'
import Cookies from 'js-cookie'
import axios from 'axios'

const SuccessComputex = () => {
  const [availableGifts, setAvailableGifts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  // let { pid } = useParams()

  useEffect(() => {
    if (!Cookies.get('hasReceivedAward')) {
      Cookies.set('hasReceivedAward', 'false', {
        expires: 4,
        secure: true,
        sameSite: 'strict',
      })
    }
    if (!Cookies.get('hasAvailableGifts')) {
      Cookies.set('hasAvailableGifts', 'unknown', {
        expires: 4,
        secure: true,
        sameSite: 'strict',
      })
    }

    // 檢查可兌換禮品
    const checkAvailableGifts = async () => {
      try {
        setIsLoading(true)
        const ac = Cookies.get('computex2025_ac')
        const tk = Cookies.get('computex2025_tk')

        const host =
          process.env.REACT_APP_HOST || 'https://nezcdev.dataa.com.tw'

        if (!ac || !tk) {
          setIsLoading(false)
          setAvailableGifts([])
          // 設置無可用禮品的 cookie
          Cookies.set('hasAvailableGifts', 'false', {
            expires: 4,
            secure: true,
            sameSite: 'strict',
          })
          return
        }

        const response = await axios.post(
          host + '/clientWeb/v1/CheckGift',
          {
            gift_ids: [
              'COMP25_01',
              'COMP25_02',
              'COMP25_03',
              'COMP25_04',
              'COMP25_05',
              'COMP25_06',
            ],
          },
          {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
              ac: ac,
              tk: tk,
            },
          }
        )

        // 過濾出可兌換的禮品
        const availableItems = response.data.data.filter(
          (item) => item.is_available_to_exchange === true
        )
        setAvailableGifts(availableItems)
        if (availableItems.length > 0) {
          Cookies.set('hasAvailableGifts', 'true', {
            expires: 4,
            secure: true,
            sameSite: 'strict',
          })
        } else {
          Cookies.set('hasAvailableGifts', 'false', {
            expires: 4,
            secure: true,
            sameSite: 'strict',
          })
        }
      } catch (error) {
        console.error('檢查禮品錯誤:', error)
        setAvailableGifts([])
        Cookies.set('hasAvailableGifts', 'false', {
          expires: 4,
          secure: true,
          sameSite: 'strict',
        })
      } finally {
        setIsLoading(false)
      }
    }

    checkAvailableGifts()
  }, [])

  // 生成禮品表格 HTML
  const generateGiftTableHtml = () => {
    // 生成表格行 HTML
    const generateTableRows = () => {
      if (isLoading) {
        return `<tr>
          <td colspan="2" style="padding: 10px; border: 1px solid #ddd; font-size: 0.95em; text-align: center;">載入中...<br>Loading...</td>
        </tr>`
      }

      return availableGifts
        .map((gift) => {
          // 從名稱和描述中提取中英文內容
          const nameParts = gift.name.split('\\n')
          const descriptionParts = gift.description.split('\\n')

          const itemCH = nameParts[0] || ''
          const itemEN = nameParts[1] || ''
          const deskCH = descriptionParts[0] || ''
          const deskEN = descriptionParts[1] || ''

          return `<tr>
  <td style="padding: 10px; border: 1px solid #ddd; font-size: 0.95em;">${itemCH}<br>${itemEN}</td>
      <td style="padding: 10px; border: 1px solid #ddd; font-size: 0.95em;">${deskCH}<br>${deskEN}</td>
        </tr>`
        })
        .join('')
    }

    return `<div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; color: #333; max-width: 100%; font-size: 16px;" class="computex2025container">
    <p style="margin: 0 0 10px 0; line-height: 1.5;">感謝您的填寫，憑問卷完成畫面，可至BenQ服務台兌換禮品一份(每人限領一次)。<br>
    Thank you for completing the survey. Please present the completion screen at the BenQ Information Desk to redeem a gift (limited to one per person).</p>

    <p style="color: #333; margin: 10px 0; font-weight: 500; font-size: 1em;">請向服務台人員出示本畫面兌換獎品<br>Please show this screen to the service desk staff to redeem your gift</p>
    
    <div style="overflow-x: auto; -webkit-overflow-scrolling: touch; margin-top: 5px;">
      <table style="width: 100%; border-collapse: collapse; margin: 0 auto; box-shadow: 0 1px 2px rgba(0,0,0,0.05);">
        <thead>
          <tr>
            <th style="padding: 10px; text-align: left; background-color: #f0f0f0; color: #333; font-weight: 600; border: 1px solid #ddd; white-space: normal; font-size: 0.95em;">品項<br>Item</th>
            <th style="padding: 10px; text-align: left; background-color: #f0f0f0; color: #333; font-weight: 600; border: 1px solid #ddd; white-space: normal; font-size: 0.95em;">兌換地點<br>Redemption Location</th>
          </tr>
        </thead>
        <tbody>
          ${generateTableRows()}
        </tbody>
      </table>
    </div>
  </div>`
  }

  // const completionMessage=''
  const [mySuccessJson, setMySuccessJson] = useState(null)
  const outerUrl = `<h3>感謝您的蒞臨參觀</h3><h3>We're honored to have you visiting us!</h3><h4><a href='https://www.benq.com/zh-tw/index.html?gad_source=1&gclid=CjwKCAjw3NyxBhBmEiwAyofDYTj1FZIhIcNQurZ02Sly1AZ56xxGQA56JUvYW34sYYHHWEt4_onCDxoC-N0QAvD_BwE'
  >BenQ website</a></h4><h4><a href='https://www.qisda.com/tw'>Qisda website</a></h4></h4><h4><a href='https://www.youtube.com/@QisdaCorp'>Qisda Youtube</a></h4>`
  useEffect(() => {
    // 檢查是否已經獲得獎品&是否有可用禮品
    const hasReceivedAward = Cookies.get('hasReceivedAward') === 'true'
    const hasAvailableGifts = Cookies.get('hasAvailableGifts') === 'true'
    const showCompletionScreen = hasReceivedAward || hasAvailableGifts === false

    if (showCompletionScreen) {
      setMySuccessJson({
        ...templateJson,
        logo: 'https://i.postimg.cc/9fLpw8NP/AI-wow-2025.jpg',
        title: '【2025 COMPUTEX】BenQ AI WOW',
        completeText: '完成',
        completedHtml: outerUrl,
        pages: [
          {
            name: 'page0',
            elements: [
              {
                type: 'panel',
                elements: [
                  {
                    type: 'html',
                    name: 'intro',
                    html: `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>The questionnaire has been successfully submitted.</h4>`,
                  },
                ],
                name: 'panel1',
              },
            ],
          },
        ],
      })
    } else {
      setMySuccessJson({
        ...templateJson,
        logo: 'https://i.postimg.cc/9fLpw8NP/AI-wow-2025.jpg',
        title: '【2025 COMPUTEX】BenQ AI WOW',
        completeText: '確認兌獎',
        completedHtml: outerUrl,
        pages: [
          {
            name: 'page0',
            elements: [
              {
                type: 'panel',
                elements: [
                  {
                    type: 'html',
                    name: 'intro',
                    html: generateGiftTableHtml(),
                  },
                  {
                    type: 'text',
                    inputType: 'number',
                    name: 'gift',
                    title:
                      '*請由「兌獎處服務人員」操作 Operation by prize counter staff only.',
                  },
                ],
                name: 'panel1',
              },
            ],
          },
        ],
      })
    }
  }, [availableGifts])

  function onSurveyValidateQuestion(survey, options) {
    if (options.name === 'gift') {
      const inputValue = options.value

      // 獲取 ac 和 tk
      const ac = Cookies.get('computex2025_ac') || ''
      const tk = Cookies.get('computex2025_tk') || ''
      const host =
        process.env.REACT_APP_API_HOST || 'https://nezcdev.dataa.com.tw'

      if (!inputValue) {
        options.error = '請輸入兌獎密碼 Please enter a redemption code'
        return
      }

      // 密碼對應表
      const passwordMap = {
        1111: 'COMP25_01', // 蜂蜜啤酒
        2222: 'COMP25_02', // 琥珀啤酒
        3333: 'COMP25_03', // 香片姍姍(茉莉綠茶)
        4444: 'COMP25_04', // 熟藏金萱
        5555: 'COMP25_05', // 乖乖濕巾
        6666: 'COMP25_06', // 客製木雕杯墊
      }

      // 檢查輸入的密碼
      if (passwordMap[inputValue]) {
        // 根據輸入的密碼選擇不同的 gift_id
        const giftId = passwordMap[inputValue]

        // 呼叫 API 兌換禮品
        axios
          .post(
            host + '/clientWeb/v1/ExchangeGift',
            {
              gift_id: giftId,
              pass: inputValue,
            },
            {
              headers: {
                'Content-Type': 'text/plain; charset=UTF-8',
                Accept: '*/*',
                ac: ac,
                tk: tk,
              },
            }
          )
          .then((response) => {
            console.log('兌換禮品成功:', response.data)

            if (response.data.code === '02050') {
              // API 請求成功後，更新 cookie
              Cookies.set('hasReceivedAward', 'true', {
                expires: 4,
                secure: true,
                sameSite: 'strict',
              })

              // 通知使用者兌換成功
              alert('禮品兌換成功！Gift redemption successful!')
            } else if (response.data.code === '03051') {
              alert('此贈品已兌換完畢 This gift has been fully redeemed.')
            } else if (response.data.code === '03059') {
              alert('此用戶已兌換 This user has already claimed the reward')
            } else {
              alert(
                '兌換失敗，請稍後再試 Redemption failed, please try again later'
              )

              options.error =
                '兌換失敗，請稍後再試 Redemption failed, please try again later'
            }

            // 可以選擇重新導向或刷新頁面
            // window.location.reload()
          })
          .catch((error) => {
            console.error('兌換禮品失敗:', error)

            // API 請求失敗，設置錯誤訊息
            options.error =
              '兌換失敗，請稍後再試 Redemption failed, please try again later'
          })
      } else {
        // 輸入的密碼不正確
        options.error =
          '請輸入正確兌獎密碼才能提交 Please enter correct password'
      }
    }
  }

  const survey = new Model(mySuccessJson)
  survey.onValidateQuestion.add(onSurveyValidateQuestion)

  return (
    <>
      <Survey model={survey} />
    </>
  )
}

export default SuccessComputex
